/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Pricing
 * The Selling Partner API for Pricing helps you programmatically retrieve product pricing and offer information for Amazon Marketplace products.
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Indicates the type of quantity discount this price applies to.
 */

export const QuantityDiscountType = {
    QuantityDiscount: 'QUANTITY_DISCOUNT',
} as const;

export type QuantityDiscountType = typeof QuantityDiscountType[keyof typeof QuantityDiscountType];



